import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';

const API_BASE   = process.env.REACT_APP_API_BASE   ;
const API_PREFIX = process.env.REACT_APP_API_PREFIX || '/api/v3';
const B = (p = '') => `${API_BASE}${API_PREFIX}${p}`;

const IMAGE_KINDS = [
  'front_view',
  'right_side_view',
  'rear_view',
  'left_side_view',
  'top_view',
  'bottom_view',
  'comes_with_image',
  'stamp_image',
  'photo_details'
];

export default function ProductDetailPage() {
  const { id } = useParams();
  const [product, setProduct] = useState(null);
  const [files, setFiles] = useState({});
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState('');

  const load = async () => {
    try {
      const res = await fetch(B(`/products/${id}`), { credentials: 'include' });
      if (!res.ok) throw new Error(`Fetch product failed: ${res.status}`);
      const json = await res.json();
      setProduct(json?.data || json);
    } catch (e) {
      setError(e.message);
    }
  };

  useEffect(() => {
    load();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);

  const onChoose = (kind, file) => {
    setFiles(prev => ({ ...prev, [kind]: file }));
  };

  const onUpload = async () => {
    try {
      setSaving(true);
      const fd = new FormData();
      Object.entries(files).forEach(([kind, file]) => {
        if (file) {
          fd.append('kind', kind);
          fd.append('file', file, file.name);
        }
      });

      const res = await fetch(B(`/products/${product.id}/images`), {
        method: 'POST',
        body: fd,
        credentials: 'include'
      });
      if (!res.ok) throw new Error(`Upload failed: ${res.status}`);

      await load();
      setFiles({});
    } catch (e) {
      setError(e.message);
    } finally {
      setSaving(false);
    }
  };

  const onDelete = async (kind) => {
    try {
      const res = await fetch(B(`/products/${product.id}/images/${encodeURIComponent(kind)}`), {
        method: 'DELETE',
        credentials: 'include'
      });
      if (!res.ok) throw new Error(`Delete failed: ${res.status}`);
      await load();
    } catch (e) {
      setError(e.message);
    }
  };

  if (!product) return <div>Loading…</div>;

  const imagesByKind = {};
  (product.images || product.product_images || []).forEach(img => {
    imagesByKind[img.kind] = img;
  });

  return (
    <div>
      <h2>Product #{product.id} — {product.sku}</h2>
      {error && <div className="alert alert-danger">{error}</div>}

      <h4 className="mt-3">Images</h4>
      <div className="row">
        {IMAGE_KINDS.map(kind => {
          const img = imagesByKind[kind];
          return (
            <div className="col-md-4 mb-3" key={kind}>
              <div className="card">
                <div className="card-header d-flex justify-content-between align-items-center">
                  <strong>{kind}</strong>
                  {img && (
                    <button className="btn btn-sm btn-outline-danger" onClick={() => onDelete(kind)}>
                      Delete
                    </button>
                  )}
                </div>
                <div className="card-body">
                  {img ? (
                    <img
                      alt={kind}
                      src={img.url || `https://cdn.belleandkate.com/${img.s3_key}`}
                      className="img-fluid"
                    />
                  ) : (
                    <div className="text-muted mb-2">No image uploaded.</div>
                  )}
                  <input
                    type="file"
                    accept="image/*"
                    className="form-control mt-2"
                    onChange={e => onChoose(kind, e.target.files?.[0] || null)}
                  />
                </div>
              </div>
            </div>
          );
        })}
      </div>

      <button className="btn btn-primary" disabled={saving} onClick={onUpload}>
        {saving ? 'Uploading…' : 'Save Uploads'}
      </button>
    </div>
  );
}
